module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--top"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__row"
  }, [_c('div', {
    staticClass: "footer__item"
  }, [_c('Icon', {
    attrs: {
      "name": "chance-logo"
    }
  }), _c('div', {
    staticClass: "footer__address-container"
  }, [_c('div', {
    staticClass: "footer__title"
  }, [_vm._v("Knoxville")]), _c('a', {
    staticClass: "footer__address",
    attrs: {
      "href": _vm.props.links.map_link,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.address)
    }
  }), _c('div', {
    staticClass: "footer__phone",
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.phone)
    }
  })]), _c('div', {
    staticClass: "footer__address-container"
  }, [_c('div', {
    staticClass: "footer__title"
  }, [_vm._v("Sweetwater")]), _c('a', {
    staticClass: "footer__address",
    attrs: {
      "href": _vm.props.links.map_link_two,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.address_two)
    }
  }), _c('div', {
    staticClass: "footer__phone",
    domProps: {
      "innerHTML": _vm._s(_vm.props.information.phone_two)
    }
  })])], 1), _c('div', {
    staticClass: "footer__item footer__item--right"
  }, [_c('div', {
    staticClass: "footer__social-container"
  }, [_c('div', {
    staticClass: "footer__social-row"
  }, _vm._l((_vm.props.links.social_links), function(link) {
    return (link.href) ? _c('a', {
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      attrs: {
        "name": link.name
      }
    })], 1) : _vm._e()
  })), _vm._m(0)])])])])]), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__email"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@chanceorthodontics.com"
    }
  }, [_vm._v("info@chanceorthodontics.com      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer--bottom"
  }, [_c('p', [_vm._v("© Copyright 2019 Chance Orthodontics ")]), _c('p', [_vm._v("Online advantage by"), _c('a', {
    attrs: {
      "href": "https://www.roostergrin.com",
      "target": "_blank"
    }
  }, [_vm._v("Rooster Grin Media")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-683acb64","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 602
// module chunks = 1